export enum VENUE_MANUAL_TAGS {
  VenuePlans = 'Venue',
  BrandPlans = 'Brand',
  Online = 'Online',
  Shopify = 'Shopify',
}

export const VENUE_MANUAL_TAGS_ARRAY = [
  { label: 'Venue Plans', value: VENUE_MANUAL_TAGS.VenuePlans },
  { label: 'Brand Plans', value: VENUE_MANUAL_TAGS.BrandPlans },
];
